import React from 'react';
import TermsConditions from "../styles/components/TermsConditions.css"
import Navigation from "../components/Navigation/Navigation.js"
import Footer from "../components/Footer.js"

export default function TermsAndConditions() {
  return (
    <>
    <Navigation />
    <div className="terms-container">
      <div className="terms-box">
        <h1>Terms & Conditions</h1>
        <p>
          Welcome to <strong>Flight Reservation Hub</strong>. By accessing or
          using our website, you agree to comply with and be bound by the
          following Terms & Conditions. Please read these carefully before using
          our services.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By using this website, you acknowledge that you have read,
          understood, and agree to these Terms & Conditions. If you do not
          agree, please do not use our services.
        </p>

        <h2>2. Services Provided</h2>
        <p>
          Flight Reservation Hub is an online platform that provides information
          and tools to help users search and book flights. We are not an airline
          and do not operate flights directly.
        </p>

        <h2>3. User Responsibilities</h2>
        <p>
          Users are responsible for ensuring the accuracy of all information
          provided during the booking process. Any fraudulent or misleading
          activity may result in termination of your access to the platform.
        </p>

        <h2>4. Payment & Refund Policy</h2>
        <p>
          Payments made through our platform are processed securely. Refunds, if
          applicable, are subject to airline policies and our refund guidelines.
          Please review all terms before completing a booking.
        </p>

        <h2>5. Limitation of Liability</h2>
        <p>
          We strive to provide accurate and updated information, but we do not
          guarantee the availability or pricing of flights. We are not liable
          for any loss, damage, or inconvenience caused by third-party services.
        </p>

        <h2>6. Changes to Terms</h2>
        <p>
          We may update these Terms & Conditions at any time without prior
          notice. Continued use of the website after changes means you accept
          the updated terms.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          If you have any questions regarding these Terms & Conditions, please
          contact us at{" "}
          <a href="mailto:support@flightreservationhub.com">
            support@flightreservationhub.com
          </a>
        </p>
      </div>
    </div>
    <Footer />
    </>
  );
}
